export function getInstallments(state) {
    return state.installments
}

export function checkContractTypeNumber(state) {
    return function (site_id, contractTypeNumber) {
        if (state.sites.length === 0) return false;
        let sites = state.sites.filter((site) => {
            return site.id === site_id && site.pivot.contract_type_number === contractTypeNumber
        })
        return sites.length > 0;

    }
}

